/**
 * Central app logger. Use for errors, warnings, and optional alert.
 * Ensures consistent formatting and a single place to add crash reporting or remote logging later.
 */

export type LogContext = Record<string, unknown>;

function formatMessage(level: string, message: string, context?: LogContext): string {
  const timestamp = new Date().toISOString();
  if (context && Object.keys(context).length > 0) {
    return `[${timestamp}] [${level}] ${message} ${JSON.stringify(context)}`;
  }
  return `[${timestamp}] [${level}] ${message}`;
}

export const appLogger = {
  error(message: string, context?: LogContext): void {
    const formatted = formatMessage('ERROR', message, context);
    console.error(formatted);
  },

  warn(message: string, context?: LogContext): void {
    const formatted = formatMessage('WARN', message, context);
    console.warn(formatted);
  },

  alert(message: string, context?: LogContext): void {
    if (__DEV__) {
      const formatted = formatMessage('INFO', message, context);
      console.log(formatted);
    }
  },
};
